export default __webpack_public_path__ + "static/media/fast-slow.30b6f69f.svg";